import { IconTextFormatSubheading } from '@components/icons/text-format-subheading';
import { getFieldContent } from '@components/text-editors/addons/field-mapping';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';

import { FieldDropzone } from './field-dropzone';
import { useTextContentActions } from './use-field-actions';
import { FieldMappingDisplay, useFieldMappingEditor } from './use-field-mapping';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

type Config = FieldConfig<'subheading'>;

const Display: Config['Display'] = ({ field }) => {
  return <FieldMappingDisplay content={field.label} textProps={{ font: 'heading2' }} />;
};

const FormBuilderSubheading: Config['Component'] = ({ field, dragHandle }) => {
  const actions = useFormBuilderContext().store.actions;
  const menuItems = useTextContentActions(field);

  const { shouldUseFieldMapping, FieldMappingEditor } = useFieldMappingEditor({
    field,
    contentKey: 'label',
    sidebarLabel: t('title'),
    fieldType: 'text',
    plaintext: true,
    singleLine: true,
  });

  const editContent = shouldUseFieldMapping ? (
    FieldMappingEditor
  ) : (
    <TextField
      onChange={actions.createChangeHandler(field, 'label')}
      defaultValue={getFieldContent(field.label)}
      label={getFieldContent(field.label)}
      hideLabel
    />
  );

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        menu={menuItems}
        display={<Display field={field} />}
        edit={editContent}
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Subheading',
  },
});

export const subheadingConfig: Config = {
  kind: 'subheading',
  title: t('title'),
  group: 'content',
  propertiesTabs: [conditionsTab],
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={getFieldContent(field.label)} />,
  Component: FormBuilderSubheading,
  Icon: IconTextFormatSubheading,
};
